import { IsoDateStr, IsoIntervalStr } from '@elderbyte/ngx-starter'
import { WorkOrderDispatch, WorkClearance } from './work-order'
import { ProdOrderPriority } from '../prod-orders/prod-order'

export class WorkOrderUpdate {
  public dispatch: WorkOrderDispatch
  public dispatchNull: boolean

  public releaseAt: IsoDateStr

  public scheduleInterval: IsoIntervalStr

  public disableAutoScheduling: boolean

  public clearance: WorkClearance

  public orderPriority: ProdOrderPriority

  constructor(public id: string) {}
}
